"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderers_1 = require("./TokenRenderers");
var react_1 = __importDefault(require("react"));
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var server_1 = __importDefault(require("react-dom/server"));
var RootRenderTokensHost_1 = __importStar(require("./RenderTokensHost/RootRenderTokensHost"));
var MakeSharedRenderProps_1 = require("./TokenRenderers/MakeSharedRenderProps");
var tokenRenderer = function (tokens, options) {
    var _a, _b;
    if (options && (options.renderMode === "react" || options.renderMode === "react-hydratable")) {
        var reactRenderer = options.renderMode === "react" ? server_1.default.renderToStaticMarkup : server_1.default.renderToString;
        var RenderTokensHost = options.renderMode === "react-hydratable" ? RootRenderTokensHost_1.default : RootRenderTokensHost_1.RootRenderTokensHost;
        return reactRenderer(react_1.default.createElement(RenderTokensHost, {
            tokens: tokens,
            allColors: (_a = options === null || options === void 0 ? void 0 : options.colorProvider) === null || _a === void 0 ? void 0 : _a.serialiseColors(),
            blockStyles: options === null || options === void 0 ? void 0 : options.blockStyles,
            printContext: (options === null || options === void 0 ? void 0 : options.isPrintMode)
                ? { isPrintMode: true, printOrientation: options.printOrientation }
                : { isPrintMode: false },
            imgixContext: { disableImgix: (_b = options === null || options === void 0 ? void 0 : options.disableImgix) !== null && _b !== void 0 ? _b : false },
            publicPageContext: { publicPageUrl: options === null || options === void 0 ? void 0 : options.secretLink },
        }));
    }
    var html = "";
    if (!tokens || !tokens.length) {
        return html;
    }
    var currentBlock = null;
    var innerHtml = "";
    var currentIndex = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type == "block") {
            if (currentBlock != undefined) {
                html += renderToken(currentBlock, currentIndex, tokens, innerHtml, options);
                innerHtml = "";
            }
            currentBlock = token;
            currentIndex = i;
        }
        else if (token.type == "inline") {
            innerHtml += renderToken(token, currentIndex, tokens, innerHtml, options);
        }
    }
    if (currentBlock) {
        html += renderToken(currentBlock, currentIndex, tokens, innerHtml, options);
    }
    else {
        html = innerHtml;
    }
    return html;
};
var makeRenderProps = function (token, index, tokens, innerHtml, options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var blockParagraphColor = "#000000";
    if (options.colorProvider && ((_a = options.blockStyles) === null || _a === void 0 ? void 0 : _a["p"])) {
        blockParagraphColor = options.colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(options.blockStyles["p"]["color"]))
            .value;
    }
    return __assign(__assign({}, (0, MakeSharedRenderProps_1.makeSharedRenderProps)(token, options)), { renderTokens: function (tokens, overrideOptions) { var _a, _b; return (_b = (_a = options.renderTokens) === null || _a === void 0 ? void 0 : _a.call(options, tokens, __assign(__assign({}, options), overrideOptions))) !== null && _b !== void 0 ? _b : ""; }, innerHtml: innerHtml, index: index, isPrintMode: (_b = options.isPrintMode) !== null && _b !== void 0 ? _b : false, publicPageLink: options.secretLink, disableImgix: (_c = options.disableImgix) !== null && _c !== void 0 ? _c : false, tokens: tokens, printOrientation: options.printOrientation, blockParagraphColor: blockParagraphColor, computeForegroundColor: options.computeForegroundColor, quoteContext: options.quoteContext, blockId: options.blockId, quoteSectionContext: options.quoteSectionContext });
};
var renderToken = function (token, index, tokens, innerHtml, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var config = (0, GetCommonConfigByType_1.getGenericCommonConfigByType)(token.subType);
    if (config) {
        return config.publicRenderHtmlString(makeRenderProps(token, index, tokens, innerHtml, options));
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { index: index, innerHtml: innerHtml, tokens: tokens, renderTokens: tokenRenderer, colorProvider: (_a = options.colorProvider) !== null && _a !== void 0 ? _a : (0, MakeSharedRenderProps_1.makeDefaultColorProvider)() }));
};
exports.default = tokenRenderer;
